module.exports = __webpack_public_path__ + "img/cns_pca1.0075aa70.png";